// Функція для визначення статусу товару (така ж логіка як в ProductStatus)
export const getProductStatus = (product) => {
  if (product.quantity > 0 && product.state === 'SOLD_OUT') {
    return 'Останні набори';
  } else if (product.quantity > 0 && product.state === 'PREORDER') {
    return 'Передзамовлення';
  } else if (product.quantity > 0 && product.state === 'ACTIVE') {
    return 'Є в наявності';
  } else if (product.state === 'OUT_OF_STOCK') {
    return 'Тимчасово недоступний';
  } else if (product.state === 'ACTIVE' && product.quantity === 0) {
    return 'Під замовлення';
  } else if (product.state === 'SOLD_OUT' && product.quantity === 0) {
    return 'Знятий з продажу';
  }
  return null;
};

// Фільтрація товарів за статусом (на фронтенді)
export const filterProductsByStatus = (products, status) => {
  if (!status) {
    return products;
  }
  return products.filter(product => getProductStatus(product) === status);
};

// Застосування пагінації до відфільтрованих товарів
export const applyPagination = (products, page, numberPerPage) => {
  const startIndex = page * numberPerPage;
  const endIndex = startIndex + numberPerPage;
  return products.slice(startIndex, endIndex);
};
